
import React, { useEffect, useState, useRef, useCallback } from "react";
import cn from "classnames";
import Revenueg from "components/echarts/Revenueg";
import Register from "components/echarts/Register";
import Frequency from "components/echarts/Frequency";
import Batteryfault from "components/echarts/Batteryfault";
import styles from "./report.module.scss"
import { getRequest, postRequest } from "services/axiosBaseClient";
import { Button } from "@material-ui/core";
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import LocalStorageService from "services/tokenlocalstorage.service";
import * as htmlToImage from "html-to-image";

function createData(hourCount, weekCount, monthCount, quarterCount) {
  return { hourCount, weekCount, monthCount, quarterCount };
}

export default  function Graph(props) {
  const [userRole, setUserRole] = useState("");
  const [navigation, setNavigation] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [swapChartdata, setSwap] = useState([])
  const [revenue,setRevenue] = useState([])
  const [register,setRegister] = useState([])
  const [fault, setFault] = useState([])
  const refOpen = useRef(open);
  const [state, setState] = React.useState({
    checkedB: true,
  });
  const swapData = [
    createData(swapChartdata.hourCount,swapChartdata.weekCount,swapChartdata.monthCount,swapChartdata.quarterCount),
  ];

  const revenueData = [
   createData (revenue.hourCount,revenue.weekCount,revenue.monthCount,revenue.quarterCount),
  ]

  const registerData = [
    createData(register.hourCount,register.weekCount,register.monthCount,register.quarterCount),
  ]

  const faultData = [
    createData(fault.hourCount,fault.weekCount,fault.monthCount,fault.quarterCount)
  ]



  const downloadFile = () => {
    window.location.href = "https://yoursite.com/src/assets/files/exampleDoc.pdf"
  }

  const xAxisData = [
    "24Hrs",
    "1 Week",

    "1Month",

    "3 Months",
  ];
  

  const color="blue";
  const getSwapList = useCallback(async () => {
    const headerFilterObj = JSON.parse(
      LocalStorageService.get("headerFilter")
    );
    var query =
      (headerFilterObj?.stateId === undefined ||
        headerFilterObj?.stateId === ""
        ? ""
        : "&stateId=" + headerFilterObj.stateId) +
      (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
        ? ""
        : "&cityId=" + headerFilterObj.cityId) +
      (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
        ? ""
        : "&zoneId=" + headerFilterObj.zoneId);
    await getRequest(
      'bss/reportsSwapListing?' + query
    )
      .then((res) => {
        if (res && res?.data) {
          setSwap(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  useEffect(() => {
    getSwapList();
  }, [props.headerFilter]);

  const getRevenueList = useCallback(async () => {
    const headerFilterObj = JSON.parse(
      LocalStorageService.get("headerFilter")
    );
    var query =
      (headerFilterObj?.stateId === undefined ||
        headerFilterObj?.stateId === ""
        ? ""
        : "&stateId=" + headerFilterObj.stateId) +
      (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
        ? ""
        : "&cityId=" + headerFilterObj.cityId) +
      (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
        ? ""
        : "&zoneId=" + headerFilterObj.zoneId);
    await getRequest(
      'bss/reportsRevenueListing?' + query
    )
      .then((res) => {
        if (res && res?.data) {
          setRevenue(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  useEffect(() => {
    getRevenueList();
  }, [props.headerFilter]);


  const getRegisterList = useCallback(async () => {
    const headerFilterObj = JSON.parse(
      LocalStorageService.get("headerFilter")
    );
    var query =
      (headerFilterObj?.stateId === undefined ||
        headerFilterObj?.stateId === ""
        ? ""
        : "&stateId=" + headerFilterObj.stateId) +
      (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
        ? ""
        : "&cityId=" + headerFilterObj.cityId) +
      (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
        ? ""
        : "&zoneId=" + headerFilterObj.zoneId);
    await getRequest(
      'bss/reportsRegisterListing?' + query
    )
      .then((res) => {
        if (res && res?.data) {
          setRegister(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  useEffect(() => {
    getRegisterList();
  }, [props.headerFilter]);


  const getBatteryFaultList = useCallback(async () => {
    const headerFilterObj = JSON.parse(
      LocalStorageService.get("headerFilter")
    );
    var query =
      (headerFilterObj?.stateId === undefined ||
        headerFilterObj?.stateId === ""
        ? ""
        : "&stateId=" + headerFilterObj.stateId) +
      (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
        ? ""
        : "&cityId=" + headerFilterObj.cityId) +
      (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
        ? ""
        : "&zoneId=" + headerFilterObj.zoneId);

    await getRequest(
      'bss/reportsBatteryFaultListing?' + query
    )
      .then((res) => {
        if (res && res?.data) {
          setFault(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  useEffect(() => {
    getBatteryFaultList();
  }, [props.headerFilter]);


  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  
  function useOutsideAlerter(ref, ref1) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpen(false);
          refOpen.current = false;
        } else {
          if (
            refOpen.current &&
            ref1.current &&
            !ref1.current.contains(event.target)
          ) {
            refOpen.current = false;
            setOpen(false);
          } else {
            setOpen(true);
            refOpen.current = true;
          }
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, ref1]);
  }

  const wrapperRef = useRef(null);
  const wrapperRefInside = useRef(null);

  useOutsideAlerter(wrapperRef, wrapperRefInside);

  const handleClick = () => {
    if (open) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  };

  const columns = [
    { title: "24Hrs", field: "hourCount", },
    { title: "1Week", field: "weekCount", },
    { title: "1Month", field: "monthCount", type: "numeric" },
    { title: "3Month", field: 'quarterCount', }]

  const downloadPdf = async () => {
    const doc = new jsPDF("p", "px");
    doc.text("Swap Graph Data", 20, 10);
    const elements = document.getElementsByClassName("echarts-for-react");
    await creatPdf({ doc, elements }, 0);
    doc.save("charts.pdf");
  };

  const downloadPdfRevenue = async () => {
    const doc = new jsPDF("p", "px");
    doc.text("Revenue Graph Data", 20, 10)
    const elements = document.getElementsByClassName("echarts-for-react");
    await creatPdf({ doc, elements }, 1);
    // doc.autoTable({
    //   theme: "grid",
    //   columns: columns.map(col => ({ ...col, dataKey: col.field })),
    //   body: revenueData
    // })
    doc.save("charts.pdf");
  }

  const downloadPdfRegister = async () => {
    const doc = new jsPDF("p", "px");
    doc.text("Register Graph Data", 20, 10)
    const elements = document.getElementsByClassName("echarts-for-react");
    await creatPdf({ doc, elements }, 2);
    doc.save("charts.pdf");
  }

  const downloadPdfFault = async () => {
    const doc = new jsPDF("p", "px");
    doc.text("Battery Fault Graph Data ", 20, 10)
    const elements = document.getElementsByClassName("echarts-for-react");
    await creatPdf({ doc, elements }, 3);
    doc.save("charts.pdf");
  };

  async function creatPdf({
    doc,
    elements
  }, count
  ) {
    const padding = 10;
    const marginTop = 20;
    let top = marginTop;
      const el = elements.item(count);
      const imgData = await htmlToImage.toPng(el);
  
  
      let elHeight = el.offsetHeight;
      let elWidth = el.offsetWidth;
  
      const pageWidth = doc.internal.pageSize.getWidth();
  
      if (elWidth > pageWidth) {
        const ratio = pageWidth / elWidth;
        elHeight = elHeight * ratio - padding * 2;
        elWidth = elWidth * ratio - padding * 2;
      }
  
      const pageHeight = doc.internal.pageSize.getHeight();
  
      if (top + elHeight > pageHeight) {
        doc.addPage();
        top = marginTop;
      }
  
      doc.addImage(imgData, "PNG", padding, top, elWidth, elHeight, `image${count}`);
      top += elHeight + marginTop;
  }
  
  return (
    <>
      <h2 className={cn(styles.medium_title, styles.medium_title_layout)}>
        {userRole.toLowerCase() === "admin"
          ? "Admin Dashboard"
          : "Reports"}
      </h2>
        <div
          className={cn(
            styles.upper_graph_flex,
            styles.upper_graph_flex_layout
          )}
        >
          <div className={cn(styles.upper_graph_flex_item)}>
            <div
              className={cn(
                styles.graph_card_view,
                styles.graph_card_view_layout
              )}
            >
              <div style={{display:"inline-block"}} className={cn(styles.block17, styles.block17_layout)}>
                <h5 style={{float:"left"}}
                  className={cn(styles.highlights1, styles.highlights1_layout)}
                >
                  {"Swap Graph"}
                </h5>    
                <button className={cn(styles.block5, styles.block5_layout)} onClick={downloadPdf} >
                <img
                  src={require("assets/downloadbtn.svg").default}
                  alt="e"
                  style={{ color: "white" ,paddingRight:"6px"}}
                />
                  Download
                </button>  
                <div>
                <Frequency
                   yAxisData={[
                    swapChartdata.hourCount,

                    swapChartdata.weekCount,

                    swapChartdata.monthCount,

                    swapChartdata.quarterCount,
                  ]}
                  xAxisData={xAxisData}
                  Gcolor={color}
                   
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={cn(styles.upper_graph_flex_spacer)} />
          <div className={cn(styles.upper_graph_flex_item)}>
            <div
              className={cn(
                styles.graph_card_view,
                styles.graph_card_view_layout
              )}
            >
              <div style={{display:"inline-block"}} className={cn(styles.block17, styles.block17_layout)}>
                <h5 style={{float:"left"}}
                  className={cn(styles.highlights1, styles.highlights1_layout)}
                >
                  {"Revenue Graph"}
                </h5>    
                <button onClick={downloadPdfRevenue} className={cn(styles.block5, styles.block5_layout)} >
                <img
                  src={require("assets/downloadbtn.svg").default}
                  alt="e"
                  style={{ color: "white" ,paddingRight:"6px"}}
                />
                  Download
                </button>
                
                <div>
                  <Revenueg 
                  yAxisData={[
                    revenue.hourCount,

                    revenue.weekCount,

                    revenue.monthCount,

                    revenue.quarterCount,
                  ]}
                  xAxisData={xAxisData}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={cn(
            styles.upper_graph_flex,
            styles.upper_graph_flex_layout
          )}
        >
          <div className={cn(styles.upper_graph_flex_item)}>
            <div
              className={cn(
                styles.graph_card_view,
                styles.graph_card_view_layout
              )}
            >
               <div style={{display:"inline-block"}} className={cn(styles.block17, styles.block17_layout)}>
                <h5 style={{float:"left"}}
                  className={cn(styles.highlights1, styles.highlights1_layout)}
                >
                  {"Register Graph"}
                </h5>    
                <button onClick={downloadPdfRegister} className={cn(styles.block5, styles.block5_layout)} >
                <img
                  src={require("assets/downloadbtn.svg").default}
                  alt="e"
                  style={{ color: "white" ,paddingRight:"6px"}}
                />
                  Download
                </button>
                
                <div>
                  <Register
                  yAxisData={[
                    register.hourCount,

                    register.weekCount,

                    register.monthCount,

                    register.quarterCount,
                  ]}
                  xAxisData={xAxisData}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={cn(styles.upper_graph_flex_spacer)} />
          <div className={cn(styles.upper_graph_flex_item)}>
            <div
              className={cn(
                styles.graph_card_view,
                styles.graph_card_view_layout
              )}
            >
              <div style={{display:"inline-block"}} className={cn(styles.block17, styles.block17_layout)}>
                <h5 style={{float:"left"}}
                  className={cn(styles.highlights1, styles.highlights1_layout)}
                >
                  {"Battery Fault Graph"}
                </h5>    
                <button  onClick={downloadPdfFault} className={cn(styles.block5, styles.block5_layout)} >
                <img
                  src={require("assets/downloadbtn.svg").default}
                  alt="e"
                  style={{ color: "white" ,paddingRight:"6px"}}
                />
                  Download
                </button>
                
                <div>
                  <Batteryfault
                   yAxisData={[
                    fault.hourCount,

                    fault.weekCount,

                    fault.monthCount,

                    fault.quarterCount,
                  ]}
                  xAxisData={xAxisData}
                  />
                </div>
              </div>
            </div>
          </div>
        </div> 
    </>
  );
}












